export const AUTH_TOKEN = 'auth_token'
export const NAME = 'name'
export const SURNAME = 'surname'